import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  key: 1,
  class: "gfu-modal__header",
  "data-qa": "box:Title"
}
const _hoisted_3 = {
  key: 0,
  class: "gfu-heading _flex _gap-2 _ai-c"
}
const _hoisted_4 = {
  key: 1,
  class: "_flexcol _gap-2 _my-3"
}
const _hoisted_5 = {
  key: 2,
  class: "gfu-subheading"
}
const _hoisted_6 = {
  key: 2,
  class: "gfu-form__footer _mt-0"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_app_portal = _resolveComponent("app-portal")

  return (_openBlock(), _createBlock(_component_app_portal, { to: "#modals" }, {
    default: _withCtx(() => [
      _createVNode(_Transition, {
        onAfterEnter: _cache[3] || (_cache[3] = $event => (_ctx.$emit('after-enter')))
      }, {
        default: _withCtx(() => [
          ($props.isVisible)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass($options.rootClasses),
                "data-qa": `modal-visible-${$props.isVisible}:${$options.effectiveDataQa}`
              }, [
                ($props.hasBackdrop)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "gfu-modal__backdrop",
                      onClick: _cache[0] || (_cache[0] = (...args) => ($options.onActionClose && $options.onActionClose(...args)))
                    }))
                  : _createCommentVNode("v-if", true),
                (_openBlock(), _createBlock(_resolveDynamicComponent($props.tag), _mergeProps({
                  class: ['gfu-modal__body', $options.bodyClasses],
                  tabindex: "0"
                }, _ctx.$attrs, { "data-qa": "modal-box:Body" }), {
                  default: _withCtx(() => [
                    ($options.hasNavigation)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(['gfu-modal__navigation', $options.navigationClasses])
                        }, [
                          ($props.showActionBack)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "_flex _tc--accent _ai-c _jc-c _gap-1 _pa-0",
                                onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.onActionBack && $options.onActionBack(...args)), ["prevent"])),
                                "data-qa": "modal-navigation-back"
                              }, [
                                _createVNode(_component_base_icon, {
                                  name: "angle-left",
                                  size: "lg"
                                }),
                                _createElementVNode("span", null, _toDisplayString(_ctx.Resources.Common.ModalBackButton), 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("v-if", true),
                          ($props.showActionClose)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "_flex _tc--accent _ai-c _jc-c _gap-1 _ml-a",
                                onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.onActionClose && $options.onActionClose(...args)), ["prevent"])),
                                "data-qa": "modal-navigation-close"
                              }, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.Resources.Common.ModalCloseButton), 1 /* TEXT */),
                                _createVNode(_component_base_icon, {
                                  name: "times",
                                  size: "lg",
                                  "data-qa": "modal-button:Close"
                                })
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */))
                      : _createCommentVNode("v-if", true),
                    ($options.hasTitle)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          ($props.title)
                            ? (_openBlock(), _createElementBlock("h1", _hoisted_3, [
                                ($props.icon !== null)
                                  ? (_openBlock(), _createBlock(_component_base_icon, {
                                      key: 0,
                                      name: $props.icon,
                                      "icon-namespace": $props.iconNamespace,
                                      class: "_tc--accent",
                                      size: "lg"
                                    }, null, 8 /* PROPS */, ["name", "icon-namespace"]))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("span", null, _toDisplayString($props.title), 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.$slots['notificators'])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _renderSlot(_ctx.$slots, "notificators")
                              ]))
                            : _createCommentVNode("v-if", true),
                          ($props.subtitle)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($props.subtitle), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(['gfu-modal__content', $options.contentClasses])
                    }, [
                      _renderSlot(_ctx.$slots, "default")
                    ], 2 /* CLASS */),
                    (_ctx.$slots['actions'])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _renderSlot(_ctx.$slots, "actions")
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_progress_overlay, {
                      class: "gfu-progress-overlay--modal",
                      visible: $props.isProcessing || _ctx.isModalProcessing,
                      message: $props.processingMessage
                    }, null, 8 /* PROPS */, ["visible", "message"])
                  ]),
                  _: 3 /* FORWARDED */
                }, 16 /* FULL_PROPS */, ["class"]))
              ], 10 /* CLASS, PROPS */, _hoisted_1))
            : _createCommentVNode("v-if", true)
        ]),
        _: 3 /* FORWARDED */
      })
    ]),
    _: 3 /* FORWARDED */
  }))
}